export default {
	TABLE_TITLE: 'Workplaces',
	WORKPLACE_ADDED: 'Workplace added',
	WORKPLACE_EDITED: 'Workplace edited',
	WORKPLACE_DELETED: 'Workplace deleted',
	DETAILS_TOOLTIP: 'Details',
	LEGACY: 'Legacy',
};
